import React, {useEffect, useState} from 'react';
import './scss/asset-view.scss';
import ReactJson from 'react-json-view';
import AssetViewProp from "./properties/asset-view";
import FullScreenLoader from "./full-screen";
import {Button} from 'react-bootstrap';
import SandraJsAPI from "../services/sandraJsAPI";
import {StatusMessageTypeEnum} from "../enums/StatusMessageTypeEnum";

function AssetView({setStatusMessage, assetId, onLoaded}: AssetViewProp): React.ReactElement {
    const jsonInit: any = {}
    const [metaData, setMetaData] = useState(jsonInit);
    const [isLoading, setIsLoading] = useState(false);
    const [assetIdText, setAssetIdText] = useState(assetId);

    const fetchAsset = () => {
        setStatusMessage("", StatusMessageTypeEnum.none);
        if (assetIdText?.trim().length > 0) {
            setIsLoading(true);
            SandraJsAPI.getAsset(assetIdText.trim()).then(res => {
                setIsLoading(false);
                if (res.error?.status) {
                    setStatusMessage(res.error.message, StatusMessageTypeEnum.error);
                } else if (res.data) {
                    setMetaData(res.data);
                    onLoaded(assetIdText, res.data.has?.refs);
                } else {
                    setStatusMessage('Unable to load asset', StatusMessageTypeEnum.error);
                }
            }).catch(e => {
                setStatusMessage(e.message, StatusMessageTypeEnum.error);
                setIsLoading(false);
            });
        }
    }

    const loadAsset = () => {
        fetchAsset();
    };

    useEffect(() => {
        fetchAsset();
    }, []);

    return (
        <div className="p-3">
            {isLoading ? <FullScreenLoader/> : <div/>}
            <h5>Asset</h5>
            <div className="pt-2 pb-3 clearfix w-100 d-flex justify-content-end">
                <input
                    type="text"
                    id="name"
                    className="form-control me-auto"
                    value={assetIdText}
                    style={{fontSize: '.85rem', width: '70%'}}
                    onChange={(e) => setAssetIdText(e.target.value)}
                    placeholder="Asset Id"
                />
                <Button variant="primary" className="w-auto ms-1" style={{fontSize: '.9rem'}}
                        onClick={loadAsset}>
                    Load Asset
                </Button>
            </div>
            <ReactJson src={metaData} style={
                {
                    fontSize: '12px',
                    backgroundColor: 'rgb(240 242 242)',
                    width: '100%',
                    padding: '1rem',
                    wordBreak: 'break-all',
                    whiteSpace: 'pre-line',
                    verticalAlign: 'bottom'
                }}
                       collapsed={1}
                       theme="apathy:inverted"/>
        </div>
    );

}

export default AssetView;
